/**
 * Règles du bandeau de campagne, communes à l'application React (components/PromoCampaignBanner.tsx)
 * et aux pages serveur (nav/promoBanner.ts, dans nav.js) : mêmes pages masquées, même clé de
 * fermeture (fermé sur une page, il ne revient sur aucune autre), même source de mesure.
 */

/** Pages où le bandeau ferait doublon ou gênerait la conversion. */
export const PAGES_SANS_BANDEAU_PROMO = [
  "/tarifs",
  "/inscription",
  "/login",
  "/paiement-confirme",
  "/espace-admin",
  "/admin",
  "/compte",
];

export const bandeauPromoMasque = (pathname: string): boolean =>
  PAGES_SANS_BANDEAU_PROMO.some((p) => pathname === p || pathname.startsWith(p + "/"));

/** Fermeture mémorisée par campagne (localStorage). */
export const cleFermeturePromo = (code: string): string => `km_promo_${code}_dismissed`;

/** cta_source du bouton : suit la campagne active (« ANNIV1AN » -> promo_anniv1an_banner). */
export function ctaSourcePromo(code: string): string {
  const slug = code.trim().toLowerCase();
  return /^[a-z0-9_-]{1,40}$/.test(slug) ? `promo_${slug}_banner` : "promo_banner";
}
